import cn from 'classnames'
import type { MouseEvent } from 'react'

import { Tooltip } from 'core-components/library/tooltip'

import { useAttentionStatusesText } from '../../hooks/useAttentionStatusesText'

import styles from './AttentionPbmReplacement.module.scss'

interface IAttentionPbmReplaceButtonProps {
  name: string
  isOpened?: boolean
  className?: string
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void
}

/** Opens the replacement of the PBM beside it, without picking the row under it. */
export const AttentionPbmReplaceButton = ({
  name,
  isOpened,
  className,
  onClick,
}: IAttentionPbmReplaceButtonProps) => {
  const text = useAttentionStatusesText()
  const label = text.replaceLabel(name)

  return (
    <Tooltip inline tipContent={() => <span>{label}</span>}>
      <button
        type="button"
        className={cn(styles.trigger, className)}
        aria-label={label}
        aria-haspopup="dialog"
        aria-expanded={isOpened}
        onClick={(event) => {
          event.stopPropagation()
          onClick?.(event)
        }}
        onKeyDown={(event) => event.stopPropagation()}
      >
        <i className="kbase kbase-arrow-left-right" aria-hidden="true" />
      </button>
    </Tooltip>
  )
}

AttentionPbmReplaceButton.displayName = 'AttentionPbmReplaceButton'
